module.exports = __webpack_public_path__ + "static/media/ExtendedLogo.9483acd5.svg";